//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "driver-info",
  data() {
    return {
      user: {},
      driver:{},
      carNumberShow: false,
      nameShow:false
    }
  },
  methods: {
    onShow(){
      if (this.carNumberShow) {
        this.$refs.carNumber.setInputValue(this.driver.carNumber);
      }else if(this.nameShow){
        this.$refs.name.setInputValue(this.driver.name);
      }
    },
    onConfirm(value){
      if(this.carNumberShow){
        this.driver['carNumber'] = value;
      }else if(this.nameShow){
        this.driver['name'] = value;
      }
      if(this.driver.suppliers){
        delete this.driver.suppliers;
      }
      this.$loadingShow();
      this.$put('api/driver',this.driver).then((res) => {
        this.$vux.toast.text('修改成功');
        this.carNumberShow = false;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      });
    },
    onCancel(){
      this.carNumberShow = false;
      this.nameShow = false;
    },
    showSupplier(){
      this.$router.push(`/driver/driver-supplier/${this.user.login}`);
    }
  },
  mounted() {
    this.$loadingShow();
    this.$get('api/person/current').then(val => {
      this.user = val;
      this.$get(`api/driver/tel/${val.login}`).then((res) => {
        this.driver = res;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    }).catch(() => {
      this.$loadingHide();
    })
  },
}



// WEBPACK FOOTER //
// ./src/page/driver/driver-info.vue